import { humanRigs, type HumanProportions, type HumanRigId } from './human.js';
import { DWARF_FACE_DEFAULT, dwarfFaceShape, dwarfSkull, resolveDwarfFace, type DwarfFaceMorph } from './dwarf-face.js';

export type DwarfRigId = 'dwarf-male' | 'dwarf-female';
export interface DwarfProportions extends HumanProportions { faceMorph: DwarfFaceMorph }
export const DWARF_RIG_VERSION = 1;
function proportions(id: DwarfRigId, motionRig: HumanRigId): DwarfProportions {
  const p = structuredClone(humanRigs[motionRig]), faceMorph = { ...DWARF_FACE_DEFAULT }, face = dwarfFaceShape(faceMorph, motionRig);
  return { ...p, id, bodyMorph: { breadth: 1.25, depth: 1.2, limbWidth: 1.18, armLength: .92, legLength: .76, torsoLength: 1.02, neckLength: .85, headSize: 1.1, handSize: 1.16 },
    muscularity: .55, muscleDefinition: .6, fatness: .16,
    faceMorph, face, skull: dwarfSkull(faceMorph, motionRig), faceNeutral: { width: 1, length: 1, noseSize: 1, eye: face.eye }, headMeshCell: .0035 };
}
export const dwarfRigs: Record<DwarfRigId, DwarfProportions> = {
  'dwarf-male': proportions('dwarf-male', 'human-male'), 'dwarf-female': proportions('dwarf-female', 'human-female'),
};
export function dwarfProportions(rig = 'dwarf-male'): DwarfProportions {
  if (!(rig in dwarfRigs)) throw new Error(`No Dwarf morph registered for rig '${rig}'.`);
  return dwarfRigs[rig as DwarfRigId];
}
export function morphDwarfProportions(source: DwarfProportions, faceId = 'standard'): DwarfProportions {
  const faceMorph = resolveDwarfFace(source.faceMorph, faceId), face = dwarfFaceShape(faceMorph, source.motionRig);
  return { ...source, faceMorph, face, skull: dwarfSkull(faceMorph, source.motionRig),
    faceNeutral: { width: 1, length: 1, noseSize: 1, eye: face.eye }, headCacheKey: `${source.id}:${faceId}:${JSON.stringify(faceMorph)}` };
}
export const dwarfStandardHeight = (rig: string) => rig === 'dwarf-female' ? 1.35 : 1.4;
